import { render, staticRenderFns } from "./Driver_masters.vue?vue&type=template&id=3c2bfd64&"
import script from "./Driver_masters.vue?vue&type=script&lang=js&"
export * from "./Driver_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports